import { useState, useEffect, useContext } from 'react';

import { RightOutlined } from '@ant-design/icons';
import { Image } from 'antd';

import { getCatalotgPopAd } from '../header-http';

import { CustomScrollbar } from './CustomScrollbar.style';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import Utils from '@lcsc-ui/utils/Utils';

function headBuriedPoint(op, data) {
  const current_h = window.location.href;
  if (data) {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: op,
      data: { current_href: current_h, ...data },
    });
  } else {
    buriedPoint({ cp: 'top_header', ty: 'click', op: op });
  }
}

const BrandContent = ({ brands }) => {
  if (brands?.length) {
    return brands.map((brand, idx) => (
      <a
        key={idx}
        href={brand?.targetLink}
        className="mb-[10px] block h-[68px] w-[122px]"
        target="_blank"
        onClick={() => headBuriedPoint('Catalog_advertisement', { hf: brand?.targetLink })}
      >
        <img
          className="h-[66px] w-[120px] rounded-[8px] border border-solid border-[#eee]"
          src={brand.advertisingUrl}
        />
      </a>
    ));
  }
};

const cache = new Map();

const SubCatalogPop = ({ subCatalogList, currentParentName, resourceData, currentParentId, currentParentIdx }) => {
  /**BOM相关的逻辑 */
  const isBomChildPage = false; // BOM 页面要做特殊判断
  /**BOM相关的逻辑 end */
  const isMroSubCatalog = currentParentName?.includes('工业品') || currentParentName?.includes('仪器仪表');

  const [catalogBrandAd, setCatalogBrandAd] = useState(null);
  useEffect(() => {
    fetchCatalogAd();
  }, [currentParentId]);

  async function fetchCatalogAd() {
    if (cache.has(currentParentId)) {
      setCatalogBrandAd(cache.get(currentParentId) || null);
      return;
    }
    try {
      const { result } = await getCatalotgPopAd({
        catalogId: currentParentId,
      });
      setCatalogBrandAd(result);
      cache.set(currentParentId, result); // 缓存结果
    } catch (error) {
      // ...
    }
  }
  return (
    <section
      className={`_lg:min-w-[1280px] absolute left-[236px] top-0 z-10 ${isMroSubCatalog ? 'h-[521px]' : 'min-h-[521px]'} min-w-[936px] bg-transparent pl-[16px]`}
      data-spm={'ca' + currentParentIdx}
    >
      <CustomScrollbar
        className={`border-lcBlue flex ${isMroSubCatalog ? 'h-[521px] overflow-y-scroll' : 'min-h-[521px]'} justify-between rounded-[10px] border border-solid bg-white p-[20px] pr-[20px]`}
      >
        <section className={`${!Utils.isEmpty(catalogBrandAd) ? '_lg:w-[980px] w-[680px]' : ''}`}>
          {subCatalogList?.map((sonCatalog, pIdx) => {
            const hasCatalogImage = sonCatalog.hasCatalogImage;
            let ktxxArea = null; // 看图选型
            if (hasCatalogImage) {
              ktxxArea = isMroSubCatalog ? (
                <a
                  className="h-[26px] w-[102px] bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con_active.svg)]"
                  // catalogName={sonCatalog.catalogName}
                  href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`}
                  target="_blank"
                  data-spm={pIdx + 1}
                ></a>
              ) : (
                <a
                  className="h-[26px] w-[102px] bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/img_con_active.svg)]"
                  href={`${resourceData.projectConfigVO.lcscWwwUrl}/catalog/config.html?catalogId=${sonCatalog.catalogId}`}
                  data-spm={pIdx + 1}
                  target="_blank"
                ></a>
              );
            }
            const itemClass = 'font-bold text-[14px] h-[19px] leading-[19px] hover:text-lcBlue custom-group';
            return (
              <section className={`${isMroSubCatalog ? 'mb-[10px]' : 'mb-[16px]'}`} key={sonCatalog.catalogId}>
                <section className="flex items-center justify-between">
                  {isBomChildPage ? (
                    <a
                      className={itemClass}
                      href={`${resourceData.projectConfigVO.lcscBomUrl}/bom/model/change-catalog-search/${sonCatalog.catalogId}.html?${location.search.slice(1)}`}
                      data-spm={pIdx + 1}
                      target="_blank"
                    >
                      <span className="mr-[13px] antialiased" title={sonCatalog.catalogName || sonCatalog.keywordName}>
                        {sonCatalog.catalogName || sonCatalog.keywordName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  ) : isMroSubCatalog ? (
                    <a
                      className={itemClass}
                      href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`}
                      target="_blank"
                      data-spm={pIdx + 1}
                      onClick={() =>
                        headBuriedPoint('PRODUCT_CATALOGUE_1', {
                          hf: `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${sonCatalog.mroCatalogId}.html`,
                          sp: sonCatalog.catalogName,
                        })
                      }
                    >
                      <span className="mr-[13px] antialiased" title={sonCatalog.catalogName}>
                        {sonCatalog.catalogName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  ) : (
                    <a
                      href={`${resourceData.projectConfigVO.lcscListUrl}/catalog/${sonCatalog.catalogId}.html`}
                      className={itemClass}
                      target="_blank"
                      data-spm={pIdx + 1}
                      onClick={() =>
                        headBuriedPoint('PRODUCT_CATALOGUE_1', {
                          hf: `${resourceData.projectConfigVO.lcscListUrl}/catalog/${sonCatalog.catalogId}.html`,
                          sp: sonCatalog.catalogName,
                        })
                      }
                    >
                      <span className="mr-[13px] antialiased" title={sonCatalog.catalogName}>
                        {sonCatalog.catalogName}
                      </span>
                      <RightOutlined className="custom-group-hover-text-lcBlue text-[10px] text-[#54657D]"></RightOutlined>
                    </a>
                  )}
                  {ktxxArea}
                </section>
                <section className={`${isMroSubCatalog ? 'mt-[10px]' : 'mt-[20px]'} flex flex-wrap items-center`}>
                  {sonCatalog.sonCatalogList?.map((s_son, idx) => {
                    let itemClassName =
                      'text-[12px] w-[150px] text-[#56657F] mr-[20px] mb-[15px] inline-block truncate hover:text-lcBlue h-[16px] leading-[16px] antialiased';
                    if (isMroSubCatalog) {
                      itemClassName += ' !w-[80px] !mb-[10px]';
                    }
                    return isBomChildPage ? (
                      <a
                        className={itemClassName}
                        href={`${resourceData.projectConfigVO.lcscBomUrl}/bom/model/change-catalog-search/${s_son.catalogId}.html?${location.search.slice(1)}`}
                        target="_blank"
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    ) : isMroSubCatalog ? (
                      <a
                        className={itemClassName}
                        href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${s_son.mroCatalogId}.html`}
                        target="_blank"
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${s_son.mroCatalogId}.html`,
                            sp: s_son.catalogName,
                          })
                        }
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    ) : (
                      <a
                        href={`${resourceData.projectConfigVO.lcscListUrl}/catalog/${s_son.catalogId}.html`}
                        className={itemClassName}
                        target="_blank"
                        data-spm={pIdx + 1 + '-' + (idx + 1)}
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: `${resourceData.projectConfigVO.lcscListUrl}/catalog/${s_son.catalogId}.html`,
                            sp: s_son.catalogName,
                          })
                        }
                        title={s_son.catalogName || s_son.keywordName}
                      >
                        {s_son.catalogName || s_son.keywordName}
                      </a>
                    );
                  })}
                  {(sonCatalog.keywordVOList || []).map((s_son, idx) => {
                    let itemClassName =
                      'mb-[15px] mr-[20px] inline-block w-[150px] truncate text-[12px] text-[#199FE9] antialiased';
                    if (isMroSubCatalog) {
                      itemClassName += ' !w-[80px] !mb-[10px]';
                    }
                    return (
                      <a
                        href={s_son.keywordUrl}
                        className={itemClassName}
                        key={s_son.keywordUrl}
                        title={s_son.keywordName}
                        data-spm={pIdx + 1 + '-' + ((sonCatalog?.sonCatalogList?.length || 0) + idx + 1)}
                        target="_blank"
                        onClick={() =>
                          headBuriedPoint('PRODUCT_CATALOGUE_2', {
                            hf: s_son.keywordUrl,
                            sp: s_son.keywordName,
                          })
                        }
                      >
                        {s_son.keywordName}
                      </a>
                    );
                  })}
                </section>
                {(sonCatalog.catalogTagVOList || []).map((s_son, idx) => {
                  let itemClassName = 'line-clamp-1 h-[25px] w-[150px] truncate text-center leading-[25px] antialiased';
                  if (isMroSubCatalog) {
                    itemClassName += ' !w-[80px]';
                  }
                  return (
                    <div
                      key={s_son.catalogTagName}
                      className={`${
                        s_son.logName === 'hot'
                          ? 'bg-[#fee] text-[#f4220f]'
                          : s_son.logName === 'recommend'
                            ? 'bg-[#FFEFE6] text-[#ff5901]'
                            : s_son.logName === 'domestic'
                              ? 'bg-[#E5EEFF] text-[#0556F5]'
                              : 'bg-[#e7f6ff] text-[#199FE9]'
                      } relative mb-[15px] mr-[20px] inline-block overflow-visible rounded-[3px] text-[12px] text-[#199FE9] antialiased`}
                    >
                      <a
                        href={`${s_son.catalogUrl}`}
                        title={s_son.catalogTagName}
                        className={itemClassName}
                        target="_blank"
                        data-spm={
                          pIdx +
                          1 +
                          '-' +
                          ((sonCatalog?.sonCatalogList?.length || 0) +
                            (sonCatalog?.keywordVOList?.length || 0) +
                            idx +
                            1)
                        }
                        onClick={() =>
                          headBuriedPoint('catalog_marketing_tag', {
                            hf: s_son.catalogUrl,
                            sp: s_son.catalogTagName,
                            user_type: Utils.isLogined() ? 1 : 0,
                            catalog_id: s_son.catalog_id,
                          })
                        }
                      >
                        {s_son.catalogTagName}
                      </a>
                      {s_son.logName ? (
                        <picture>
                          <img
                            alt={s_son.logName}
                            src={`https://static.szlcsc.com/ecp/assets/newWeb/header/${s_son.logName}.svg`}
                            className={`absolute right-[-10px] top-[-10px] z-[1] h-[16px] w-[29px]`}
                          />
                        </picture>
                      ) : null}
                    </div>
                  );
                })}
              </section>
            );
          })}
        </section>
        {!Utils.isEmpty(catalogBrandAd) && (
          <section className="pl-[12px]">
            <h3 className="mb-[16px] text-[14px] font-bold">{catalogBrandAd[0].title}</h3>
            <BrandContent brands={catalogBrandAd} />
          </section>
        )}
      </CustomScrollbar>
    </section>
  );
};

const CatalogsPop = ({ resourceData }) => {
  const [subCatalogVisible, setSubCatalogVisible] = useState(false);
  const [subCatalogList, setSubCatalogList] = useState(null);
  const [currentParentName, setCurrentParentName] = useState(null);
  const [currentParentId, setCurrentParentId] = useState(null);
  const [currentParentIdx, setCurrentParentIdx] = useState(null);

  const { catalogList } = useContext(LayoutContext);

  if (catalogList) {
    const finalCatalogList = [];
    for (const key in catalogList) {
      if (Object.hasOwnProperty.call(catalogList, key)) {
        const element = catalogList[key];
        if (finalCatalogList.length < 15) {
          finalCatalogList.push(element);
        }
      }
    }

    const showSubCatalog = (sonCatalogList, parentName, parentId, parentIdx) => {
      setCurrentParentName(parentName);
      setCurrentParentId(parentId);
      setSubCatalogVisible(true);
      setCurrentParentIdx(parentIdx);
      setSubCatalogList(sonCatalogList);
    };

    const hideSubCatalog = () => {
      setSubCatalogList([]);
      setSubCatalogVisible(false);
      setCurrentParentName(null);
      setCurrentParentIdx(null);
    };

    const gkdqTargetId = Utils.findFirstMroCatalogId(catalogList, '工控电气');

    return (
      <ul className={`relative`} onMouseLeave={hideSubCatalog} data-spm="hd">
        <a
          data-spm="ca"
          href={Domains.lcscWwwUrl + '/catalog.html'}
          target="_blank"
          className="custom-group mb-[10px] ml-[20px] flex items-center pt-[15px] text-[16px] font-bold"
          onMouseEnter={hideSubCatalog}
          onClick={() =>
            headBuriedPoint('PRODUCT_CATALOGUE', {
              hf: resourceData.projectConfigVO.lcscWwwUrl + '/catalog.html',
            })
          }
        >
          <span>分类</span>
          <RightOutlined className="ml-[5px] text-[12px]" />
        </a>
        {finalCatalogList.map((value, idx) => {
          return (
            <li
              key={idx}
              className={`hover:text-lcBlue custom-group relative h-[31px] w-full cursor-pointer pl-[20px] text-[14px] leading-[30px] hover:bg-white`}
              onMouseEnter={() => showSubCatalog(value.sonCatalogList, value.catalogName, value.catalogId, idx + 1)}
            >
              {value.catalogName.includes('工业品') || value.catalogName.includes('仪器仪表') ? (
                <a
                  ignore-spm
                  className="industrial flex antialiased"
                  data-title={value.catalogName}
                  title={value.catalogName}
                  href={
                    value.catalogName.includes('仪器仪表') && gkdqTargetId
                      ? `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${gkdqTargetId}.html`
                      : resourceData.projectConfigVO.lcscMroUrl
                  }
                  target="_blank"
                >
                  {value.catalogName}
                  {value.isNew && (
                    <Image
                      className="upnew relative left-[3px] top-[3px]"
                      width={22}
                      height={22}
                      src="//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/upnew.svg"
                      style={{ verticalAlign: 'middle', marginLeft: '2px' }}
                      preview={false}
                    />
                  )}
                </a>
              ) : (
                <div className="industrial flex antialiased" data-title={value.catalogName} title={value.catalogName}>
                  {value.catalogName}
                  {value.isNew && (
                    <Image
                      className="upnew relative left-[3px] top-[3px]"
                      width={22}
                      height={22}
                      src="//static.szlcsc.com/ecp/assets/web/layout/catalogs/images/upnew.svg"
                      style={{ verticalAlign: 'middle', marginLeft: '2px' }}
                      preview={false}
                    />
                  )}
                </div>
              )}
            </li>
          );
        })}
        <li>
          {subCatalogVisible && (
            <SubCatalogPop
              key={currentParentId}
              subCatalogList={subCatalogList}
              currentParentName={currentParentName}
              currentParentId={currentParentId}
              currentParentIdx={currentParentIdx}
              resourceData={resourceData}
            />
          )}
        </li>
      </ul>
    );
  }
  return (
    <ul className={`relative pl-[20px]`}>
      <h3 className="mb-[12px] pt-[10px] text-[18px] font-bold">获取数据中</h3>
    </ul>
  );
};

export default CatalogsPop;
